import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';
import HIcon from '../../payment/components/HIcon.tsx';

export interface FundMessage { user: { avatar?: string; full_name: string }; content: string; date: string }

function Message({ message }: { message: FundMessage }) {
  return (
    <>
      {/* begin::Header */}
      <div className='d-flex align-items-center mb-3'>
        {/* begin::User */}
        <div className='d-flex align-items-center flex-grow-1'>
          <HIcon
            image={message.user.avatar}
            text={message.user.full_name}
            size={45}
            className={'me-3'}
          />

          {/* begin::Info */}
          <div className='d-flex flex-column'>
            <a
              href='#'
              className='text-gray-800 text-hover-primary fs-6 fw-bold'
            >
              {message.user.full_name}
            </a>
            <span className='text-gray-500 fw-semibold'>
              {formatDistanceToNow(message.date)}
            </span>
          </div>
          {/* end::Info */}
        </div>
        {/* end::User */}
      </div>
      {/* end::Header */}

      {/* begin::Post */}
      <div className='mb-7'>
        {/* begin::Text */}
        <div className='text-gray-800 mb-5'>{message.content}</div>
        {/* end::Text */}
      </div>
      {/* end::Post */}
    </>
  );
}

export default Message;
